var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 29,
    viewBox: "0 0 20 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 5.8C1.91776 5.8 0.5 4.50163 0.5 2.9C0.5 1.29837 1.91776 0 3.66667 0C5.41557 0 6.83333 1.29837 6.83333 2.9C6.83333 4.50163 5.41557 5.8 3.66667 5.8ZM3.66667 17.4C1.91776 17.4 0.5 16.1016 0.5 14.5C0.5 12.8984 1.91776 11.6 3.66667 11.6C5.41557 11.6 6.83333 12.8984 6.83333 14.5C6.83333 16.1016 5.41557 17.4 3.66667 17.4ZM3.66667 29C1.91776 29 0.5 27.7016 0.5 26.1C0.5 24.4984 1.91776 23.2 3.66667 23.2C5.41557 23.2 6.83333 24.4984 6.83333 26.1C6.83333 27.7016 5.41557 29 3.66667 29ZM16.3333 5.8C14.5844 5.8 13.1667 4.50163 13.1667 2.9C13.1667 1.29837 14.5844 0 16.3333 0C18.0822 0 19.5 1.29837 19.5 2.9C19.5 4.50163 18.0822 5.8 16.3333 5.8ZM16.3333 17.4C14.5844 17.4 13.1667 16.1016 13.1667 14.5C13.1667 12.8984 14.5844 11.6 16.3333 11.6C18.0822 11.6 19.5 12.8984 19.5 14.5C19.5 16.1016 18.0822 17.4 16.3333 17.4ZM16.3333 29C14.5844 29 13.1667 27.7016 13.1667 26.1C13.1667 24.4984 14.5844 23.2 16.3333 23.2C18.0822 23.2 19.5 24.4984 19.5 26.1C19.5 27.7016 18.0822 29 16.3333 29Z",
    fill: "#3182CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDnd);
export default __webpack_public_path__ + "static/media/icon_dnd.70bee3cb7fec5ab228c80b469aabb832.svg";
export { ForwardRef as ReactComponent };